import React, { useEffect, useState } from "react";
import Section_title from "../../../common-components/section-title/Section_title";
import Form from "react-bootstrap/Form";
import { Link } from "react-router-dom";
import Select from "react-select";
import { IndexUse } from "./IndexUse";
import { IDS } from "../../../../utils/IDS";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import classNames from "classnames";
import Pagination_Holder from "../../../common-components/Pagination_Holder/Pagination_Holder";
import Table_search from "../../../common-components/table-search/Table_search";
import Delete_Modal from "../../../common-components/common_Modal/Delete_Modal/Delete_Modal";
import Delete_Confirm_Modal from "../../../common-components/common_Modal/Delete_Confirm_Modal/Delete_Confirm_Modal";
import { formatDate } from "../../../../utils/common";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGift } from "@fortawesome/free-solid-svg-icons";
import Confirm_Status_Change from "../../../common-components/common_Modal/Confirm_Status_Change/Confirm_Status_Change";
const Country = () => {
  const dispatch = useDispatch();

  const Permission = useSelector((state) => state.auth?.admin_info);

  const {
    gift,
    name,
    setName,
    fetch,
    modalMessage,
    modalShow,
    setModalShow,
    type,
    setType,
    toggleStatus,
    setContactNo,
    contactNo,
  } = IndexUse();

  const handlePageChange = async (page) => {
    await fetch(page);
  };
  const [rdelete, setRDelete] = useState(false);
  const [err, setErr] = useState(false);
  console.log(gift, "gift");

  const types = [
    { value: "Driver", label: "Driver" },
    { value: "Customer", label: "Customer" },
  ];

  const handleStatusChange = async (id) => {
    const success = await toggleStatus(id);

    if (success) {
      await fetch();
      setRDelete(false);
      setStatusConfirmModal(false);
    } else {
      setErr(true);
    }
  };

  const [statusConfirmModal, setStatusConfirmModal] = useState(false);
  const handleStatusModal = async (id) => {
    await setStatusConfirmModal(id);
  };

  return (
    <section className="content_body section_box">
      <div className="top_title_sec">
        <div className="forms_section">
          <div className="row align-items-end">
            <div className="col-md-12">
              <Section_title title="Gift History" alltotal="" />
            </div>
            {/* <div className="col-md-5 mb-3 ps-0">
            <Table_search name={name} setName={setName} fetch={fetch} />
          </div> */}
            <div className="col-md-4 mb-3 form-group">
              <label className="form-label">Filter by User Name</label>
              <Form.Control
                type="text"
                placeholder="Enter User Name"
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
            </div>

            <div className="col-md-4 mb-3 form-group">
              <label className="form-label">Filter by User Contact No</label>
              <Form.Control
                type="number"
                placeholder="Enter Contat No"
                value={contactNo}
                onChange={(e) => setContactNo(e.target.value)}
              />
            </div>
            <div className="col-md-4 mb-3 form-group">
              <label className="form-label">Filter by Type</label>
              <Form.Select
                value={type}
                onChange={(e) => setType(e.target.value)}
              >
                <option value="">All Types</option>
                {types.map((item) => (
                  <option key={item.value} value={item.value}>
                    {item.label}
                  </option>
                ))}
              </Form.Select>
            </div>
            <div className="col-md-4 mb-3" style={{ width: "fit-content" }}>
              <button
                className="btn btn-danger "
                onClick={() => {
                  setName("");
                  setType("");
                  setContactNo("");
                }}
              >
                Reset
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className="table_section theme_bg">
        <div className="table-responsive">
          <table className="table table-bordered table-striped">
            <thead>
              <tr>
                <th>S. no.</th>
                <th>Type</th>
                <th>User Name</th>
                <th>User Number</th>
                <th>Total Bookings</th>
                <th>Amount</th>
                <th>Gift</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              {gift?.data?.data?.length > 0 ? (
                gift?.data.data?.map((val, index) => (
                  <tr key={index}>
                    <td>
                      {(gift?.data?.current_page - 1) * gift?.data?.per_page +
                        index +
                        1}
                    </td>
                    <td>{val?.User?.Role?.name}</td>
                    <td>{val?.User?.first_name || "-"}</td>
                    <td>{val?.User?.contact_no}</td>
                    <td>{val?.booking_count}</td>
                    <td>{val?.Gift?.amount}</td>
                    <td
                      style={{
                        textAlign: "center",
                        verticalAlign: "middle",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          width: "100%",
                          height: "100%",
                        }}
                      >
                        {val?.Gift?.image ? (
                          <>
                            <img
                              src={`${IDS.IMG_URL}${val?.Gift?.image}`}
                              alt="Image"
                              className="tableimg"
                              style={{
                                width: "200px",
                                height: "200px",
                                objectFit: "contain",
                              }}
                              onError={(e) => {
                                e.target.style.display = "none";
                                e.target.nextSibling.style.display = "flex";
                              }}
                            />

                            <div
                              style={{
                                display: "none",
                                alignItems: "center",
                                justifyContent: "center",
                                width: "100px",
                                height: "100px",
                                background: "#f1f1f1",
                                borderRadius: "10px",
                              }}
                            >
                              <FontAwesomeIcon icon={faGift} size="4x" />
                            </div>
                          </>
                        ) : (
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              width: "100px",
                              height: "100px",
                              background: "#f1f1f1",
                              borderRadius: "10px",
                            }}
                          >
                            <FontAwesomeIcon icon={faGift} size="4x" />
                          </div>
                        )}
                      </div>
                    </td>
                    <td
                      className={val?.status ? "text-success" : "text-danger"}
                    >
                      {val?.status ? (
                        "Received"
                      ) : (
                        <Form.Check
                          type="switch"
                          id={`custom-switch-${val?.id}`}
                          checked={val?.status}
                          onClick={() => handleStatusModal(val?.id)}
                          label={val?.status ? IDS.ACTIVE : IDS.PENDING}
                        />
                      )}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="4" className="text-center">
                    No Data
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      <Pagination_Holder
        onPageChange={gift?.data?.current_page}
        totalPages={gift?.data?.total_pages}
        handlePageChange={handlePageChange}
      />
      <Confirm_Status_Change
        handleStatusChange={handleStatusChange}
        show={statusConfirmModal}
        onHide={() => setStatusConfirmModal(false)}
      />
    </section>
  );
};

export default Country;
